export const formatPrice = (price) => {
    const currency_symbol = "₺"
    return price.toLocaleString('tr-TR', {
        style: 'currency',
        currency: 'TRY',
        minimumFractionDigits: 2,
    }).replace(currency_symbol, '') + ' TL';
};